import { render, staticRenderFns } from "./ConnectNowAppListItem.vue?vue&type=template&id=196d046a"
import script from "./ConnectNowAppListItem.vue?vue&type=script&lang=js"
export * from "./ConnectNowAppListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports